module.exports = __webpack_public_path__ + "static/img/nc_mit_xfoce_existing_2025.e681df4.jpg";